import { useState, type ReactElement } from 'react';
import { getListadoInscription } from '../../services/datosGenerales.service';
import CTNButton from '@ctn/ui/components/ctn-button';
import Notificacion from '../../components/Notificacion';
import CTNButtonsGroup from '@ctn/ui/components/ctn-buttons-group';

const ListadoInscritos = (): ReactElement => {
	const [code, setCode] = useState<number | undefined>(undefined);
	const [showButtoEnviar, setShowButtoEnviar] = useState<boolean>(true);

	const contentSuccess = {
		titulo: 'Correo enviado correctamente',
		detalle: 'En breve recibirá un correo electrónico',
	};

	const contentError = {
		titulo: 'No se ha podido realizar el envío del correo',
		detalle: 'Por favor, pulse el siguiente botón y vuelva a intentarlo',
	};

	const loadListadoInscripciones = async () => {
		try {
			const response = await getListadoInscription();
			if (response.code === 200) {
				setCode(200);
				setShowButtoEnviar(false);
			} else {
				throw new Error('Error en la respuesta');
			}
		} catch (error) {
			setCode(500);
			setShowButtoEnviar(false);
			console.log(error);
		}
	};

	const handleEnviarEmail = () => {
		loadListadoInscripciones();
	};

	return (
		<div className="[ o-layout__body ] [ p-home ]">
			{showButtoEnviar ? (
				<CTNButtonsGroup align="center" className="u-mt-16">
					<CTNButton
						key="confirmar baja"
						className="c-jt-button c-jt-button--email"
						label="ENVIAR LISTADO DE INSCRITOS"
						type="submit"
						size="size-40"
						onClick={handleEnviarEmail}
					/>
				</CTNButtonsGroup>
			) : (
				<Notificacion code={code ?? 0} contentSuccess={contentSuccess} contentError={contentError} />
			)}
		</div>
	);
};

export default ListadoInscritos;
